<template>
  <div class="app-container tip-record-list">
    <div class="tip-record-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="tip-record-list-filter-value" placeholder="打赏类型" v-model="search.tipType" clearable size="small">
              <el-option
                v-for="item in tipTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="tip-record-list-filter-value" placeholder="目标类型" v-model="search.targetType" clearable size="small">
              <el-option
                v-for="item in targetTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="tip-record-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="tip-record-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class = "member-tip-record-list-container">
      <avue-crud ref="crud"
                 :option="tipRecordTableOption"
                 :data="tableData"
                 :page="page"
                 :table-loading="tableLoading"
                 @current-change="handleCurrentChange"
                 @size-change="handleSizeChange">

        <template slot="tipType" slot-scope="scope">
          {{ scope.row.tipType.label }}
        </template>
        <template slot="targetType" slot-scope="scope">
          {{ scope.row.targetType.label }}
        </template>
        <template slot="targetId" slot-scope="scope">
          <a href="javascript:void(0);" @click="toTargetDetail(scope.row);"
              class="tip-record-list-container-button">
            {{scope.row.targetId}}</a>
        </template>
        <template slot="targetMemberName" slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.targetMemberId);"
              class="tip-record-list-container-button">
            {{scope.row.targetMemberName}}</a>
        </template>
        <template slot="tipperName" slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.tipper);"
              class="tip-record-list-container-button">
            {{scope.row.tipperName}}</a>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { fetchTipRecordPage } from '@/api/tip/record';
import { tipRecordTableOption, tipTypeOptions, targetTypeOptions } from '@/const/crud/tip/record';

export default {
  data () {
    return {
      tipRecordTableOption,
      tipTypeOptions,
      targetTypeOptions,
      search: {
        current: 1,
        size: 10,
        tipType: null,
        targetType: null,
      },
      tableData:[],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableLoading: false,
    }
  },
  async activated() {
    this.getList();
  },
  async created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = this.getParams();
      this.tableLoading = true;
      fetchTipRecordPage(params).then(response => {
        this.tableData = this.formatData(response.data.data.records);
        this.page.total = response.data.data.total;
        this.tableLoading = false;
      })
    },
    formatData(records) {
      if (records && records.length > 0) {
        records.forEach(function(record, index) {
          if (!record.tipType) {
            record.tipType = { label: '其他', value: -1 }
          } else {
            record.tipType = tipTypeOptions.find(item => item.value == record.tipType)
          }
          if (!record.targetType) {
            record.targetType = { label: '其他', value: -1 }
          } else {
            record.targetType = targetTypeOptions.find(item => item.value == record.targetType)
          }
          record.targetMemberName = record.targetMemberName || "--"
          record.tipperName = record.tipperName || "--"
        })
      }
      return records
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = this.search.size;
      this.search.current = 1;
    },
    getParams() {
      let params = {
        current: this.search.current,
        size: this.search.size
      }

      if (this.search.tipType && this.search.tipType !== -1)
        params.tipType = this.search.tipType;
      if (this.search.targetType && this.search.targetType !== -1)
        params.targetType = this.search.targetType;
      return params;
    },
    toMemberDetail(id) {
      if (id){
        this.$router.push({
          path: `/upms/member/detail/${id}`,
        })
      } else {
        this.$message({
          showClose: true,
          message: '用户不存在',
          type: 'warning'
        })
      }
    },
    toTargetDetail(row) {
      if (row.targetType.value === 1) {
        if (row.targetId){
          this.$router.push({
            path: `/content/list/detail/${row.targetId}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '该帖子不存在',
            type: 'warning'
          })
        }
      }
    },
    searchChange() {
      this.initPage();
      this.getList();
    },
    searchReset() {
      this.search.tipType = null;
      this.search.targetType = null;
      this.searchChange();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.search.current = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.search.size = val;
      this.getList();
    },
  }
}
</script>

<style lang="scss" scoped>
.tip-record-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
  .tip-preview {
    display: flex;
    align-items: center;
    .tip-cover-image {
      display: flex;
      width: fit-content;
      margin-right: 12px;
      cursor: pointer;
      img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        max-width: 100%;
      }
    }
  }
  .handle-dialog {
    display: flex;
    flex-direction: column;
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 50px 0px;
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
  }
  .operate-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    .el-tooltip {
      margin-left: 8px;
    }
  }
}
</style>
